import styled from "styled-components";

import { v } from "../../styles/variables";

export const SLayout = styled.div`
    display: flex;
    flex-direction: row;
`;

export const SMain = styled.main`
    padding: ${props => props.onIsIncoming ? '0' : `calc(${v.smSpacing} * 2)`};

    h1 {
        font-size: 14px;
    }
`;

export const FormDivider = styled.div`
    height: 1px;
    width: 100%;
    border-bottom: 1px solid #a3a3a3;
    margin-top: 3em;
    margin-bottom: 3em;

    &:after {
        content: "${props => props.onDividerText}";
        font-size: 10pt;
        color: #a3a3a3;
        position: relative;
        background-color: #fff;
        top: -1em;
        left: 40%;
        padding: 1em;
    }
`;